import { render, staticRenderFns } from "./mainSideLeft.vue?vue&type=template&id=232bf75c&"
import script from "./mainSideLeft.vue?vue&type=script&lang=js&"
export * from "./mainSideLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports